import React from 'react';
import { Typography } from '@material-ui/core';
import Descriptions from 'antd/es/descriptions';
import { OneEquipment } from '../../models/data/Equipment';
import { AuthenticatedContextType } from '../../context/AuthenticatedContext';
import useStyles, {
  contentStyle,
  dataDispWidth,
  labelStyle,
  userContentStyle,
  userLabelStyle,
} from '../../css/style';

interface DataProps {
  userdata: AuthenticatedContextType;
  data: OneEquipment | undefined;
}

const DataDisp: React.FC<DataProps> = ({ userdata, data }) => {
  const classes = useStyles();
  const customerName = userdata.loginCustomer?.customerName ?? '';
  const corporateCode = userdata.loginCustomer?.corporateCode ?? '';

  // Itemコンポーネントの定義
  interface ItemProps {
    content1: string | number; // 項目内容
    content2: string | number; // 項目内容
  }

  const ItemDivision: React.FC<ItemProps> = ({ content1, content2 }) => {
    return (
      <Typography className={classes.descriptionItem}>
        <Typography className={classes.description7}>{content1}</Typography>
        <Typography className={classes.description3}>{content2}</Typography>
      </Typography>
    );
  };

  return (
    <div>
      {/* ユーザ情報 */}
      <Descriptions
        bordered
        column={1}
        labelStyle={userLabelStyle}
        contentStyle={userContentStyle}
        style={{ marginBottom: '10px', width: dataDispWidth.userInfo }}
      >
        <Descriptions.Item label="ユーザ名" span={1}>
          {`${corporateCode} ◇ ${customerName}`}
        </Descriptions.Item>
      </Descriptions>
      {/* 基本情報 */}
      <Descriptions
        bordered
        column={2}
        contentStyle={contentStyle}
        labelStyle={labelStyle}
        style={{ marginBottom: '10px', width: dataDispWidth.eqMaintBase }}
      >
        <Descriptions.Item label="顧客名" span={1}>
          <ItemDivision
            content1={data?.custName ?? ''}
            content2={data?.corporateCode ?? ''}
          />
        </Descriptions.Item>
        <Descriptions.Item label="設備No." span={1}>
          {data?.eqNo ?? ''}
        </Descriptions.Item>
        <Descriptions.Item label="事業所名" span={1}>
          <ItemDivision
            content1={data?.officeName ?? ''}
            content2={data?.siteCode ?? ''}
          />
        </Descriptions.Item>
        <Descriptions.Item label="建物名称" span={1}>
          {data?.institution ?? ''}
        </Descriptions.Item>
        <Descriptions.Item label="設備名" span={1}>
          <ItemDivision
            content1={data?.equipmentName ?? ''}
            content2={data?.equipmentId ?? ''}
          />
        </Descriptions.Item>
        <Descriptions.Item label="設備設置場所" span={1}>
          {data?.eqLocation ?? ''}
        </Descriptions.Item>
        <Descriptions.Item label="備考" span={2}>
          {data?.biko ?? ''}
        </Descriptions.Item>
      </Descriptions>
    </div>
  );
};

export default DataDisp;
